import {useColorMode} from '../../util/useColorMode';

const NIGHT_MODE_REVERT_FILTER =
  'brightness(80%) contrast(120%) hue-rotate(180deg) invert(100%)';

export function useNightModeRevertFilter(): string | undefined {
  const {isDarkMode} = useColorMode();
  return isDarkMode ? NIGHT_MODE_REVERT_FILTER : undefined;
}
